import download from 'downloadjs';

export class Downloader {
    public static DownloadFile(url: string, includeCred: boolean = true, name: string | undefined = undefined) {
        return fetch(url, {
            method: 'GET',
            credentials: includeCred ? "include" : "same-origin",
        }).then((resp) => {
            if (name == undefined) {
                let header = resp.headers.get("Content-Disposition");
                if (header != null) {
                    name = header.split("filename=")[1];
                    if (name.startsWith('"') && name.endsWith('"')) {
                        name = name.substr(1, name.length - 2);
                    }
                }
            }
            return resp.blob();
        }).then((blob) => {
            download(blob, name);
        });
    }
}

